module.exports = __webpack_public_path__ + "static/media/outlet.d05db683.svg";